// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { changePasswordStyles } from "@awc/Overrides/Widgets/ChangePassword/ChangePassword";
import { styledBoxStyle } from "@awc/XDL/Components/Common/Box";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

changePasswordStyles.passwordRequirementsGridItem = {
    width: 12,
};

changePasswordStyles.passwordGridContainer = {
    gap: 8,
};

changePasswordStyles.passwordGridItemContainer = {
    gap: 12,
    css: css`
        ${xScreen("lte", "md")} {
            margin-bottom: 20px;
        }
    `,
};

changePasswordStyles.actionsGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        padding-top: 16px;
        ${xScreen("lte", "md")} {
            order: 2;
            padding-top: 0;
            padding-bottom: 16px;
        }
    `,
};

changePasswordStyles.userInformationTextGridItem = {
    width: 12,
};

changePasswordStyles.userInformationText = changePasswordStyles.userInformationTitle = {
    variant: "h4",
    as: "h2",
    css: css`
        margin-bottom: 0;
        padding-bottom: 16px;
        padding-top: 20px;
    `,
};

changePasswordStyles.signOutWarningText = {
    css: css`
        padding-bottom: 24px;
        display: block;
    `,
};

changePasswordStyles.textFieldStyle = {
    labelProps: {
        css: css`
            width: 40%;
            text-align: left;
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            flex-grow: 1;
        `,
        formField: css`
            align-items: start;
        `,
    },
};

changePasswordStyles.passwordRequirementsGridContainer = {
    gap: 0,
    css: css`
        ${styledBoxStyle}
        margin-left: 24px;
        ${xScreen("lte", "md")} {
            margin-left: 0;
        }
    `,
};
changePasswordStyles.passwordGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        ${xScreen("lte", "md")} {
            order: 1;
        }
    `,
};

changePasswordStyles.passwordReqGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        ${xScreen("lte", "md")} {
            order: 3;
        }
    `,
};
